<template>
    <paper class="fork-list">
        <m-pane
            ref="tablePage"
            :config="config"
            :totalData="totalData"
            :pageTotal="page.pageTotal"
            :loading="loading"
            :searchTotalTitle="config.searchTotalTitle"
            :currentPage="page.currentPage"
            searchId="forkList"
            pageID="pendingDriverList"
            @searchChange="searchChange"
            @pageChange="pageChange"
            @sizeChange="sizeChange"
            >
            <div slot="table-module-btn">
                <div class="icon-button">
                    <el-tooltip effect="dark" content="导出" placement="bottom">
                        <span class="mgl-10">
                        <el-button icon="el-icon-upload2" class="bigData-btn-export" size="mini" @click="handleExport"></el-button>
                        </span>
                </el-tooltip>
                </div>
            </div>
        </m-pane>
    </paper>
</template>
<script>
import paper from '@/components/core/paper/Paper';
import mPane from '@/components/supplierPanel';
import config from './config';
import { dictWithUrl } from '@/components/lots/api';
import { getForkTruckInfo, exportForkTruckList } from '../../../../api/forkTruck';
import { mapState } from 'vuex';
export default {
    components: { paper, mPane },
    data() {
        return {
            loading: false,
            totalData: [],
            searchObj: {},
            config,
            page: {
                currentPage: 1,
                pageSize: 10,
                pageTotal: 0
            },
            dict: []
        };
    },
    computed: {
        ...mapState(['supplier'])
    },
    methods: {
        getTableData(params = { pageNo: this.page.currentPage, pageSize: this.page.pageSize }) { // 获取表格数据
            params = Object.assign(params, this.searchObj);
            const isSupplier = !!this.supplier;
            params.supplierCode = isSupplier ? this.supplier.supplierCode : ''; // 供应商平台端要加上当前账户的供应商编码
            getForkTruckInfo(params).then(res => {
                if (res && +res.code === 0) {
                    this.page.pageTotal = res.data.totalCount;
                    this.totalData = this.handleResult(res.data.list);
                }
            });
        },
        handleResult(list) {
            list.forEach(item => {
                item['newFlag'] = item['newFlag'] === 0 ? '是' : '否';
                item['enableFlag'] = item['enableFlag'] === 0 ? '启用' : '停用';
                item['deviceType'] = this.dict['SRM_DEVICE_TYPE_NAME'][item['deviceType']];
                item['deviceBrand'] = this.dict['SRM_EQUIPMENT_BRAND'][item['deviceBrand']];
            });
            return list;
        },
        searchChange(data) { // 点击查询
            this.page.currentPage = 1;
            this.searchObj = data;
            this.getTableData();
        },
        pageChange(currentPage) { // 切换分页页数
            this.page.currentPage = currentPage;
            this.getTableData();
        },
        sizeChange(pageSize) { // 切换分页显示条数
            this.page.pageSize = pageSize;
            this.getTableData();
        },
        handleExport() { // 导出
            if (this.totalData.length > 0) {
                const params = Object.assign({ pageNo: this.page.currentPage, pageSize: this.page.pageSize }, this.searchObj);
                const isSupplier = !!this.supplier;
                params.supplierCode = isSupplier ? this.supplier.supplierCode : ''; // 供应商平台端要加上当前账户的供应商编码
                this.$confirm('是否确定导出?', '导出确认', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消'
                }).then(() => {
                    exportForkTruckList(JSON.stringify(params)).then(res => {
                        const blob = new Blob([res], {
                            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                        });
                        const objectUrl = URL.createObjectURL(blob);
                        const a = document.createElement('a');
                        a.href = objectUrl;
                        a.download = '叉车数据列表.xlsx';
                        a.click();
                        this.$message.success('导出成功');
                    });
                });
            } else {
                this.$message.warning('无可用数据导出');
            }
        }
    },
    mounted() {
        dictWithUrl('SRM_DEVICE_TYPE_NAME,SRM_EQUIPMENT_BRAND').then(res => {
            this.dict = res.data;
            this.getTableData();
        });
    }
};
</script>
